export const MY_GROOV = "My Groov";
export const GROOVY_STUFF = "More places to Groov";
